<template>
  <div class="field_wrapper" :style="`background-color: ${bg}`">
    <h1>{{ fieldData.fieldTitle }}</h1>
    <div class="field_content content_wrapper">
      <div class="field_item item-center" v-for="(item, index) in fieldData.items" :key="item.id">
        <img :src="item.imgSrc" :alt="item.id" />
        <p v-if="item.intro1">{{ item.intro1 }}</p>
        <p v-if="item.intro2">{{ item.intro2 }}</p>
        <h4 class="title" v-if="item.title">
          提供SDK接口快速接入
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fieldData: {
      type: Object,
    },
    bg: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.field_wrapper {
  width: 100%;
  background-color: #fff;
  padding-bottom: 70px;
  h1 {
    margin: 0;
    padding: 70px 0px;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
  }
  .field_content {
    // padding-bottom: 0px;
    // padding: 40px 70px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .field_item {
      padding: 40px 70px;
      background-color: #fff;
    }
    img {
      max-width: 90px;
      margin-bottom: 30px;
    }
    p {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #010101;
      margin-bottom: 6px;
      line-height: 20px;
    }
  }
}
</style>